module.exports = __webpack_public_path__ + "static/Gong-272170e58bdfb9369f2ab7ff7f4ff3a1.jpg";